import { useEffect, useState } from "react";
import IMAGES from "../../../constant/IMAGES";

export function CalendarHeader(): React.ReactElement {
  function useScrolled() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
      const handleScroll = () => {
        setScrolled(window.scrollY > 10);
      };

      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return scrolled;
  }
  const scrolled = useScrolled();

  return (
    <header
      style={
        scrolled
          ? { background: "transparent" }
          : {
              background:
                "linear-gradient(90deg, #FFE8BF 0%, rgba(255,232,191,0) 100%)",
            }
      }
      className="sticky top-0 z-30 w-full border-b border-[#FFE29E] transition-all duration-300"
    >
      <div className="mx-auto flex h-[68px]  items-center justify-between px-4 md:px-10">
        <div className="flex items-center gap-3">
          <img
            src={IMAGES.headerLogo}
            alt="Phong Thủy Đại Nam"
            className="h-full w-full  object-contain"
          />
        </div>

        <div className="text-right text-sm font-bold text-[#A62A26] md:text-[18px]">
          Vì cuộc sống An Lạc - Thịnh Vượng
        </div>
      </div>
    </header>
  );
}
